export default __webpack_public_path__ + "static/media/Icon feather-check-circle.b92e7bc6.svg";